<form #myForm="ngForm" (ngSubmit)="_onSubmit(myForm.form)">
	<mat-label class="font-bold text-lg">{{ label }}</mat-label>
	<div class="flex flex-col">
		<div class="flex mt-2">
			<app-dropdown
				label="Title"
				[disabled]="false"
				[itemGroups]="titleOptions"
				[ngModel]="title"
				name="title"
				(onSelect)="setTitle($event)"
			></app-dropdown>
			<app-input
				class="ml-3"
				label="First name"
				name="labels.FIRST_NAME"
				type="text"
				[required]="_required"
				[submitted]="myForm.submitted"
				[(ngModel)]="_firstName"
			></app-input>
			<app-input
				class="ml-3"
				label="Last name"
				name="labels.LAST_NAME"
				type="text"
				[required]="_required"
				[submitted]="myForm.submitted"
				[(ngModel)]="_lastName"
			></app-input>
		</div>
		<div class="flex items-start mt-2">
			<app-radio-group
				label="Gender"
				[items]="genderOptions"
				class="flex ml-3"
				[(ngModel)]="gender"
				name="gender"
				type="compact"
			></app-radio-group>
		</div>
		<div class="flex justify-between mt-2">
			<mat-label class="font-bold">Contact details</mat-label>
			<app-checkbox
				[label]="checkboxLabel"
				(click)="setAddress($event)"
			></app-checkbox>
		</div>
		<div class="flex justify-between mt-2">
			<app-input
				label="Work phone"
				name="labels.WORK_PHONE"
				type="tel"
				[(ngModel)]="_workPhone"
			></app-input>
			<app-input
				class="ml-3"
				label="Cell phone"
				name="labels.PHONE_NUMBER"
				type="tel"
				[(ngModel)]="_phoneNumber"
			></app-input>
		</div>
		<div class="flex justify-between mt-2">
			<app-input
				label="Fax"
				name="labels.FAX"
				type="tel"
				[(ngModel)]="_fax"
			></app-input>
			<app-input
				class="ml-3"
				label="Email"
				name="labels.EMAIL"
				type="email"
				[email]="true"
				[(ngModel)]="_email"
			></app-input>
		</div>
		<div class="flex justify-between mt-3">
			<app-button type="button" btn="secondary" size="small" mat-dialog-close
				>Cancel</app-button
			>
			<app-button
				type="submit"
				size="small"
				[loading]="loading"
				[disabled]="myForm.pristine"
			>
				<span *ngIf="this._id; else create"> Update </span>
				<ng-template #create> Create </ng-template>
			</app-button>
		</div>
	</div>
</form>
